"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StrictAccessError extends Error {
    constructor(object, key) {
        const objectJson = JSON.stringify(object);
        super(`Could not access property ${key} in object ${objectJson}`);
        Object.setPrototypeOf(this, StrictAccessError.prototype);
    }
}
exports.default = StrictAccessError;
